import { kea } from 'kea'
import PropTypes from 'prop-types'

import { removeLanguageUrlFromPath } from 'lib/utils/links'

import router from '~/scenes/layout/router'
import profilePhotoLogic from '~/scenes/layout/logic'

import controller from './controller.rb'

export default kea({
  initScene: {
    scene: 'profilePublic',

    reload: () => {
      const path = removeLanguageUrlFromPath(window.location.pathname) || ''

      if (path === '/profile') {
        return controller.myProfile({})
      }

      if (path.split('/')[1] === 'in') {
        return controller.index({ url: path.split('/')[2] })
      }

      if (path.split('/')[1] === 'profiles') {
        return controller.index({ id: path.split('/')[2] })
      }

      return controller.index(router.values.params)
    },

    transform: payload => ({
      id: payload.id,
      user: payload.user,
      courses: payload.courses,
      hasCourses: payload.hasCourses,
      reputation: payload.reputation,
      reviews: payload.reviews,
      facebookFriends: payload.facebookFriends,
      isTeacher: payload.isTeacher,
      showEditProfileLink: payload.showEditProfileLink,
      showAddVerificationLink: payload.showAddVerificationLink,
      video: payload.video,
      helmet: payload.helmet
    })
  },

  connect: {
    props: [profilePhotoLogic, ['avatar']]
  },
  selectors: ({ selectors }) => ({
    userData: [
      () => [selectors.user, selectors.avatar],
      (user, avatar) => {
        return avatar ? { ...user, avatarUrl: avatar } : user
      },
      PropTypes.object
    ]
  }),
  actions: () => ({
    gotMoreReviews: ({ reviews }) => ({ reviews }),
    loadMore: true,
    translateReview: (reviewId, locale) => ({ reviewId, locale }),
    gotReviewTranslation: review => ({ review })
  }),

  reducers: ({ actions }) => ({
    id: [null, PropTypes.number, {}],
    user: [null, PropTypes.object, {}],
    courses: [null, PropTypes.array, {}],
    hasCourses: [null, PropTypes.bool, {}],
    reputation: [null, PropTypes.object, {}],
    helmet: [{}, PropTypes.object, {}],
    reviews: [
      null,
      PropTypes.array,
      {
        [actions.gotMoreReviews]: (state, { reviews }) => {
          return { ...state, reviews: [...state.reviews, ...reviews] }
        },
        [actions.gotReviewTranslation]: (state, { review }) => {
          const reviews = state.reviews.map(stateReview => (stateReview.id === review.id ? review : stateReview))

          return { ...state, reviews }
        }
      }
    ],
    facebookFriends: [null, PropTypes.object, {}],
    isTeacher: [null, PropTypes.bool, {}],
    showEditProfileLink: [null, PropTypes.bool, {}],
    showAddVerificationLink: [null, PropTypes.bool, {}],
    video: [null, PropTypes.object, {}],
    translating: [
      false,
      PropTypes.bool,
      {
        [actions.translateReview]: () => true,
        [actions.gotReviewTranslation]: () => false
      }
    ],
    isLoading: [
      false,
      PropTypes.bool,
      {
        [actions.loadMore]: () => true,
        [actions.gotMoreReviews]: () => false
      }
    ]
  }),

  listeners: ({ actions, values }) => ({
    [actions.loadMore]: async function () {
      const { gotMoreReviews } = actions
      const { id } = values
      const response = await controller.loadReviews({ id })
      gotMoreReviews(response)
    }
  })
})
